var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteWithCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11916",
    "data-name": "Group 11916",
    transform: "translate(-1355 -445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11915",
    "data-name": "Group 11915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3881",
    "data-name": "Group 3881",
    transform: "translate(1355.217 445)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-0.217)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4125",
    "data-name": "Group 4125",
    transform: "translate(-81.967 -546.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4125-2",
    "data-name": "Group 4125",
    transform: "translate(87.75 552.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M95.4,559.03H88.021a.272.272,0,0,1-.271-.271v-1.3a.707.707,0,0,1,.706-.706H94.97a.707.707,0,0,1,.706.706v1.3A.272.272,0,0,1,95.4,559.03Zm-7.111-.543h6.84v-1.031a.163.163,0,0,0-.163-.163H88.456a.163.163,0,0,0-.163.163Z",
    transform: "translate(-87.75 -556.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4126",
    "data-name": "Group 4126",
    transform: "translate(88.184 554.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M96.1,571.59H90.456a.707.707,0,0,1-.706-.706v-5.862a.272.272,0,0,1,.271-.271h6.514a.272.272,0,0,1,.271.271v5.862A.706.706,0,0,1,96.1,571.59Zm-5.808-6.3v5.591a.163.163,0,0,0,.163.163H96.1a.163.163,0,0,0,.163-.163v-5.591Z",
    transform: "translate(-89.75 -564.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4127",
    "data-name": "Group 4127",
    transform: "translate(90.356 551.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M102.193,553.378h-2.171a.271.271,0,0,1-.271-.271v-.651a.706.706,0,0,1,.706-.706h1.3a.706.706,0,0,1,.706.706v.651A.271.271,0,0,1,102.193,553.378Zm-1.9-.543h1.628v-.38a.163.163,0,0,0-.163-.163h-1.3a.163.163,0,0,0-.163.163Z",
    transform: "translate(-99.75 -551.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4128",
    "data-name": "Group 4128",
    transform: "translate(89.921 555.93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1483",
    "data-name": "Rectangle 1483",
    width: 0.543,
    height: 4.125,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4129",
    "data-name": "Group 4129",
    transform: "translate(91.441 555.93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1484",
    "data-name": "Rectangle 1484",
    width: 0.543,
    height: 4.125,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4130",
    "data-name": "Group 4130",
    transform: "translate(92.961 555.93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1485",
    "data-name": "Rectangle 1485",
    width: 0.543,
    height: 4.125,
    transform: "translate(0 0)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWithCircle);
export default __webpack_public_path__ + "static/media/deleteWithCircle.e9fd893f26e614a4939285f5d5f5fa52.svg";
export { ForwardRef as ReactComponent };